import { query, request } from '@/utils/request';
import { stringify } from 'qs';

const prefix = '';
// const prefix = 'http://yapi.cai-inc.com/mock/3005';

// 机构部门树
export async function getDepartmentTree(institutionId) {
  const url = institutionId
    ? `${prefix}/api/zlbuser/institution/depart/tree?institutionId=${institutionId}`
    : `${prefix}/api/zlbuser/institution/depart/tree`;
  return request(url);
}

/**
 * 根据id查询下一级组织
 * @param organizationId   机构或部门id
 * @param organizationType 组织类型
 * @return Response
 */
export async function getDownstreamDepartment(params) {
  return request(`${prefix}/api/zlbuser/institution/subordinate/institution?${stringify(params)}`);
}

export async function getDownstreamDepartmentSplit(params) {
  return query(
    `${prefix}/api/zlbuser/institution/subordinate/institutionWithRelevance?${stringify(params)}`,
  );
}

// 删除部门
export async function deleteDepartment(data) {
  return request(`${prefix}/api/zlbuser/institution/delete/department?${stringify(data)}`, {
    method: 'post',
  });
}
// 编辑部门
export async function createDepartment(data) {
  return request(`${prefix}/api/zlbuser/institution/create/department`, {
    method: 'post',
    data,
  });
}

// 编辑部门
export async function updateDepartment(data) {
  return request(`${prefix}/api/zlbuser/institution/update/department`, {
    method: 'post',
    data,
  });
}
// 编辑单位
export async function updateInstitution(data) {
  return request(`${prefix}/api/zlbuser/institution/update/dealmanager`, {
    method: 'post',
    data,
  });
}

// 单位详细
export async function getInstitutionDetail(params) {
  return request(`${prefix}/api/zlbuser/institution/institution/pre/update?${stringify(params)}`);
}
// 部门详细
export async function getDepartmentDetail(params) {
  return request(`${prefix}/api/zlbuser/institution/department/pre/update?${stringify(params)}`);
}
// 根据操作人员所在机构获取机构或部门主管列表
export async function getOrganizationManager(params) {
  return request(`${prefix}/api/user/organization/manager?${stringify(params)}`);
}

export async function saveSortInstitution(data) {
  return query(`${prefix}/api/zlbuser/institution/updateSort`, {
    method: 'post',
    data,
  });
}
